<template>
    <main class="main with-sidebar">
        <div class="container">
            <div v-if="visible">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="page-header">
                            <h1>
                                {{ $t('label.account') }}
                            </h1>
                        </div>

                    </div>
                </div>

                <div class="row">

                    <div class="col-lg-12 col-md-12 col-sm-12">

                        <form class="form mobile-margin-top-30" @submit.prevent="validateForm">

                            <div class="row">
                                <div class="col-lg-6">
                                    <label>{{ $t('label.language') }}</label>
                                    <div class="select">
                                        <select name="language" v-model="user.personal.language">
                                            <option v-for="language in languages" :value="language" :selected="language">{{ $t('languages.' + language) }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 mobile-margin-bottom-20">
                                    <input-widget
                                            :label="$t('label.first_name')"
                                            :type="'text'"
                                            v-model="user.first_name"
                                            validate="required"
                                    >
                                    </input-widget>
                                </div>
                                <div class="col-lg-6">
                                    <input-widget
                                            :label="$t('label.last_name')"
                                            :type="'text'"
                                            v-model="user.last_name"
                                            validate="required"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <label>{{ $t('label.birthday') }}</label>
                                    <datepicker class="with-icon"
                                                v-model="user.birthday"
                                                :disabledDate="disableDate"></datepicker>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.email')"
                                            :type="'email'"
                                            :readonly="'readonly'"
                                            v-model="user.email"
                                            :description="getChangeEmail()"
                                    >
                                    </input-widget>
                                    <span :class="{ 'button-full': true, 'button-edit': true, 'active': this.emailChange }" @click="toggleEmailChange">{{ $t('label.change') }}</span>
                                </div>
                            </div>

                            <div class="row" v-if="emailChange">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.newEmail')"
                                            :placeholder="$t('label.newEmail')"
                                            :type="'email'"
                                            v-model="email"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.password')"
                                            :placeholder="$t('label.password')"
                                            :type="'password'"
                                            :readonly="!this.passwordChange"
                                            v-model="password"
                                    >
                                    </input-widget>
                                    <span :class="{ 'button-full': true, 'button-edit': true, 'active': this.passwordChange }" @click="togglePasswordChange">{{ $t('label.change') }}</span>
                                </div>
                            </div>

                            <div class="row" v-if="passwordChange">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.repeatPassword')"
                                            :placeholder="$t('label.repeatPassword')"
                                            :type="'password'"
                                            v-model="passwordConfirmation"
                                    >
                                    </input-widget>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="button-wrapper-left">
                                        <input type="submit" :value="$t('button.save')" :class="{'button-full': true, 'loading': loading}" />
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
  import Vue from 'vue'
  import auth from '@/auth'
  import InputWidget from '@/components/widgets/InputWidget'
  import AvatarWidget from '@/components/widgets/AvatarWidget'
  import Datepicker from '@/components/widgets/datepicker/VueDatepickerLocal'

  export default {
    name: 'Account',
    components: {
      InputWidget, AvatarWidget, Datepicker
    },
    created () {
      this.getAccount()
    },
    data () {
      return {
        visible: false,
        loading: false,
        user: {},
        emailChange: false,
        passwordChange: false,
        email: null,
        password: null,
        passwordConfirmation: null
      }
    },
    methods: {
      getAccount () {
        this.$api.get('/v1/account').then(response => {
          this.user = response.data.data
          this.visible = true
        }).catch((error) => {
          console.error(error)
        })
      },
      validateForm () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.updateAccount()
          }
        })
      },
      updateAccount () {
        this.loading = true
        let formData = this.createFormData()
        this.$api.post('/v1/account', formData).then(() => {
          auth.setLanguage(this.user.personal.language)
          Vue.set(this.$i18n, 'locale', auth.getLanguage())
          let lang = this.$i18n.locale
          if (lang === 'rs') lang = 'sr-cyrl'
          this.$moment.locale(lang)

          this.user.personal.email_change = this.email
          this.passwordChange = false
          this.emailChange = false
          this.email = null
          this.loading = false
          this.$events.fire('message-open', {
            type: 'success',
            message: this.$t('message.saveSuccess')
          })
        }).catch(() => {
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.saveFailed')
          })
          this.loading = false
        })
      },
      createFormData () {
        let data = []
        data['first_name'] = this.user.first_name
        data['last_name'] = this.user.last_name
        data['language'] = this.user.personal.language
        if (this.user.birthday) {
          data['birthday'] = this.$moment(this.user.birthday).format('YYYY-MM-DD')
        }
        if (this.emailChange) {
          data['email_changed'] = this.email
        }
        if (this.passwordChange) {
          data['password_changed'] = this.password
          data['password_changed_confirmation'] = this.passwordConfirmation
        }
        let formData = new FormData()

        for (let entry in data) {
          if (data[entry] === null || typeof data[entry] === 'undefined') {
            continue
          }
          formData.append(entry, data[entry])
        }

        return formData
      },
      toggleEmailChange () {
        this.emailChange = !this.emailChange
      },
      getChangeEmail () {
        if (this.user.personal.email_change) {
          return this.$t('label.requestedChange') + ': ' + this.user.personal.email_change
        }
      },
      togglePasswordChange () {
        this.passwordChange = !this.passwordChange
        this.paswordConfirmation = null
      },
      disableDate (time) {
        return time > new Date()
      }
    },
    computed: {
      languages () {
        return Object.keys(this.$i18n.messages)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Account.vue